"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectsDataProvider = exports.useProjectsDataContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const Commons_1 = require("src/configeek_assets/src/components/common/provider/Commons");
const typescriptAddons_1 = require("src/configeek_assets/src/system/typescriptAddons");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const ActorsProvider_1 = require("src/configeek_assets/src/components/common/provider/ActorsProvider");
const ICCanisterUtils_1 = require("src/configeek_assets/src/ic/ICCanisterUtils");
const ConfigRegistryApi_1 = require("src/configeek_assets/src/ic/ConfigRegistryApi");
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
const react_dom_1 = require("react-dom");
const initialContextValue = {
    projects: {},
    projectsCumulativeInfo: (0, Commons_1.getDefaultCGFeature)()
};
const ProjectsDataContext = React.createContext(undefined);
const useProjectsDataContext = () => {
    const context = React.useContext(ProjectsDataContext);
    if (!context) {
        throw new Error("useProjectsDataContext must be used within a ProjectsDataContext.Provider");
    }
    return context;
};
exports.useProjectsDataContext = useProjectsDataContext;
const ProjectsDataProvider = (props) => {
    const actorsContext = (0, ActorsProvider_1.useActorsContext)();
    const [projects, updateProjects] = (0, react_1.useReducer)(Commons_1.featureByKeyReducer, initialContextValue.projects);
    const [projectsCumulativeInfo, updateProjectsCumulativeInfo] = (0, react_1.useReducer)(Commons_1.simpleFeatureReducer, initialContextValue.projectsCumulativeInfo);
    const fetchProjects = (0, react_1.useCallback)(async () => {
        try {
            updateProjectsCumulativeInfo({ status: { inProgress: true } });
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                if (process.env.NODE_ENV === "development") {
                    // await delayPromise(1000)
                    // throw new Error("Temp error!" + (+new Date))
                }
                const getParticipantProjectsResult = await managementActor.getParticipantProjects();
                // console.log("ProjectsDataProvider.fetchProjects: getParticipantProjectsResult", getParticipantProjectsResult);
                if ((0, ICCanisterUtils_1.isOk)(getParticipantProjectsResult)) {
                    const now = DateTimeUtils_1.DateTimeUtils.now();
                    const projectData = await getProjectsDataFromViews(getParticipantProjectsResult.ok, actorsContext.getConfigRegistryActor);
                    // console.log("ProjectsDataProvider.fetchProjects: projectData", projectData);
                    const newProjectsByKey = {};
                    lodash_1.default.each(projectData, v => {
                        newProjectsByKey[v.view.project.projectApiKey] = {
                            status: { inProgress: false, loaded: true },
                            error: { isError: false, error: undefined },
                            data: v,
                            time: { updatedAt: now },
                        };
                    });
                    (0, react_dom_1.unstable_batchedUpdates)(() => {
                        updateProjects(newProjectsByKey);
                        updateProjectsCumulativeInfo({
                            status: { inProgress: false, loaded: true },
                            error: { error: undefined, isError: false },
                            time: { updatedAt: now },
                        });
                    });
                    return;
                }
                else if ((0, ICCanisterUtils_1.isErr)(getParticipantProjectsResult)) {
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(getParticipantProjectsResult);
                    (0, react_dom_1.unstable_batchedUpdates)(() => {
                        updateProjects({});
                        updateProjectsCumulativeInfo({
                            status: { inProgress: false, loaded: true },
                            error: { error: new Error(errorName), isError: true },
                        });
                    });
                    return;
                }
            }
            else {
                throw new Error("noActor");
            }
            // noinspection ExceptionCaughtLocallyJS
            throw new Error("unknown");
        }
        catch (e) {
            console.log("ProjectsDataProvider.fetchProjects: caught error", e);
            (0, react_dom_1.unstable_batchedUpdates)(() => {
                updateProjects({});
                updateProjectsCumulativeInfo({
                    status: { inProgress: false, loaded: true },
                    error: { error: e, isError: true }
                });
            });
        }
    }, [actorsContext.getManagementActor, actorsContext.getConfigRegistryActor]);
    const hasProjects = (0, react_1.useCallback)(() => {
        return !lodash_1.default.isEmpty(projects);
    }, [projects]);
    const getProject = (0, react_1.useCallback)((projectApiKey) => {
        var _a;
        return projectApiKey ? (_a = projects[projectApiKey]) === null || _a === void 0 ? void 0 : _a.data : undefined;
    }, [projects]);
    const getProjects = (0, react_1.useCallback)((projectApiKeys) => {
        if (lodash_1.default.isEmpty(projectApiKeys)) {
            return lodash_1.default.compact(lodash_1.default.map(projects, p => p.data));
        }
        return lodash_1.default.compact(lodash_1.default.map(projectApiKeys, projectApiKey => { var _a; return (_a = projects[projectApiKey]) === null || _a === void 0 ? void 0 : _a.data; }));
    }, [projects]);
    const getLastCreatedProject = (0, react_1.useCallback)(() => {
        const sortedProjects = lodash_1.default.sortBy(getProjects(), v => -v.view.project.createdTimeSeconds);
        return lodash_1.default.first(sortedProjects);
    }, [getProjects]);
    const createProject = (0, react_1.useCallback)(async (projectName) => {
        try {
            console.log("ProjectsDataProvider.createProject: projectName", projectName);
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                if (process.env.NODE_ENV === "development") {
                    // await delayPromise(500)
                    // return {status: "error", reason: "validationError"}
                }
                const result = await managementActor.createProject(projectName);
                console.log("ProjectsDataProvider.createProject: result", result);
                if ((0, ICCanisterUtils_1.isOk)(result)) {
                    const createdProjectApiKey = result.ok;
                    return { status: "success", result: createdProjectApiKey };
                }
                else if ((0, ICCanisterUtils_1.isErr)(result)) {
                    const error = result.err;
                    console.error(`ProjectsDataProvider.createProject: got error`, error);
                    if ((0, typescriptAddons_1.hasOwnProperty)(error, "validationError")) {
                        const validationError = error.validationError;
                        const validationErrorName = (0, ICCanisterUtils_1.getICFirstKey)(validationError);
                        return { status: "error", reason: validationErrorName };
                    }
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(result);
                    return { status: "error", reason: errorName };
                }
            }
            else {
                return { status: "unknownError", error: new Error("noActor") };
            }
            return { status: "unknownError", error: new Error("unknown") };
        }
        catch (e) {
            return { status: "unknownError", error: e };
        }
    }, [actorsContext.getManagementActor]);
    const renameProject = (0, react_1.useCallback)(async (projectApiKey, projectName) => {
        try {
            if (!!process.env.IS_TEST_SERVER) {
                console.log("renameProject: projectApiKey", projectApiKey);
                console.log("renameProject: projectName", projectName);
            }
            const managementActor = await actorsContext.getManagementActor();
            if (managementActor) {
                if (process.env.NODE_ENV === "development") {
                    // await delayPromise(500)
                    // return {status: "error", reason: "projectNotFound"}
                }
                const result = await managementActor.updateProjectName(projectApiKey, projectName);
                if ((0, ICCanisterUtils_1.isOk)(result)) {
                    return { status: "success", result: projectApiKey };
                }
                else if ((0, ICCanisterUtils_1.isErr)(result)) {
                    const error = result.err;
                    console.error(`ProjectsDataProvider.renameProject: got error`, error);
                    if ((0, typescriptAddons_1.hasOwnProperty)(error, "validationError")) {
                        const validationError = error.validationError;
                        const validationErrorName = (0, ICCanisterUtils_1.getICFirstKey)(validationError);
                        return { status: "error", reason: validationErrorName };
                    }
                    const errorName = (0, ICCanisterUtils_1.getICRequestErrName)(result);
                    return { status: "error", reason: errorName };
                }
            }
            else {
                return { status: "unknownError", error: new Error("noActor") };
            }
            return { status: "unknownError", error: new Error("unknown") };
        }
        catch (e) {
            return { status: "unknownError", error: e };
        }
    }, [actorsContext.getManagementActor]);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        projects,
        projectsCumulativeInfo,
        fetchProjects,
        hasProjects,
        getProject,
        getProjects,
        getLastCreatedProject,
        createProject,
        renameProject,
    }), [
        projects,
        projectsCumulativeInfo,
        fetchProjects,
        hasProjects,
        getProject,
        getProjects,
        getLastCreatedProject,
        createProject,
        renameProject,
    ], lodash_1.default.isEqual);
    return React.createElement(ProjectsDataContext.Provider, { value: value }, props.children);
};
exports.ProjectsDataProvider = ProjectsDataProvider;
const getProjectsDataFromViews = async (views, getConfigRegistryActor) => {
    //тут из вьюшек получаем данные API и пустой стейт
    const promises = [];
    const viewsMapped = lodash_1.default.mapKeys(views, v => v.project.projectApiKey);
    lodash_1.default.each(viewsMapped, projectView => {
        const projectApiKey = projectView.project.projectApiKey;
        promises.push(getConfigStoreMgtApiPromise(projectApiKey, getConfigRegistryActor));
    });
    const promiseAllResult = await Promise.all(promises);
    // console.log("getProjectsDataFromViews: promiseAllResult", promiseAllResult);
    const projectData = lodash_1.default.map(promiseAllResult, promiseResult => {
        const [projectApiKey, promiseValue, error] = promiseResult;
        return {
            view: viewsMapped[projectApiKey],
            api: promiseValue,
            error: error
        };
    });
    return projectData;
};
const getConfigStoreMgtApiPromise = async (projectApiKey, getConfigRegistryActor) => {
    try {
        const configRegistryApi = new ConfigRegistryApi_1.ConfigRegistryApi(projectApiKey, getConfigRegistryActor);
        const configRegistryResponse = await configRegistryApi.callConfigRegistryRecursively();
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getConfigStoreMgtApiPromise: configRegistryResponse", configRegistryResponse);
        }
        if ((0, ICCanisterUtils_1.isOk)(configRegistryResponse)) {
            const getConfigStoreMgtApiResult = configRegistryResponse.ok;
            // console.log("getConfigStoreMgtApiPromise: getConfigStoreMgtApiResult", getConfigStoreMgtApiResult);
            const principal = getConfigStoreMgtApiResult.canister;
            // console.log("getConfigStoreMgtApiPromise: principal", principal);
            const accessToken = getConfigStoreMgtApiResult.accessToken;
            const projectConfigStoreApi = {
                projectApiKey: projectApiKey,
                canisterId: principal.toText(),
                accessToken: accessToken
            };
            return [projectApiKey, projectConfigStoreApi, undefined];
        }
        else if ((0, ICCanisterUtils_1.isErr)(configRegistryResponse)) {
            return [projectApiKey, undefined, new Error("Cannot get ConfigStore Api")];
        }
    }
    catch (e) {
        return [projectApiKey, undefined, e];
    }
    return [projectApiKey, undefined, new Error("unknown")];
};
